import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "./DoctorWebsite.css";
import { LanguageContext } from "./LanguageContext";
export default function MediaCarousel() {
  const articles = [
    {
      id: 1,
      title: "Ülkemizde Çocuklarda Aşı Takvimi Nasıldır?",
      link: "https://bulutklinik.com/makale/ulkemizde-cocuklarda-asi-takvimi-nasildir",
    },
    {
      id: 2,
      title: "Demir Eksikliği Hakkında Her Şey",
      link: "https://www.doktorsitesi.com/blog/makale/demir-eksikligi-hakkinda-her-sey",
    },
    {
      id: 3,
      title: "6. hastalık hakkında merak edilenler",
      link: "https://oced.org.tr/6-hastalik-hakkinda-merak-edilenler/",
    },
  ];
  const videos = [
    {
      id: 1,
      src: "haber.jpeg",
      link: "https://www.youtube.com/watch?v=9A3nY8TQq2I&t=1s",
    },
    {
      id: 2,
      src: "https://img.youtube.com/vi/nVm3IZxt1Ec/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=nVm3IZxt1Ec",
    },
    {
      id: 3,
      src: "https://img.youtube.com/vi/u9OblILt8d0/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=u9OblILt8d0",
    },
    {
      id: 4,
      src: "https://img.youtube.com/vi/ECEpgIAY5bc/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=ECEpgIAY5bc",
    },
    {
      id: 5,
      src: "https://img.youtube.com/vi/hMG0QWGrvqw/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=hMG0QWGrvqw&t=6s",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => {
    if (currentIndex + 3 < videos.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const { lang, toggleLanguage } = useContext(LanguageContext);

  const content = {
    tr: {
      appointment: "Randevu Al",
      aboutme: "Hakkımda",
      media: "Medya",
      opinion: "Görüşler",
      faq: "İletişim",
      socials: "Bana Ulaş",
      yayın: "Yayınlar",
    },
    en: {
      appointment: "Make an Appointment",
      aboutme: "About Me",
      media: "Media",
      opinion: "Opinions",
      faq: "Contact",
      socials: "Contact Me",
      yayın: "Publications",
    },
  };
  return (
    <div className="media-section">
      <header className="main-header">
        <div className="header-left">
          <Link to="/">
            <img src="/logo.png" alt="Logo" className="logo" />
          </Link>
        </div>

        <div className="header-center">
          <nav className="nav-links">
            <a href="/#about">{content[lang].aboutme}</a>
            <a href="/medya" className="text-blue-600 hover:underline">
              {content[lang].media}
            </a>
            <a href="/reviews">{content[lang].opinion}</a>
            <a href="/contact">{content[lang].faq}</a>
          </nav>
          <div className="underline" />
        </div>

        <div className="header-right">
          <button onClick={toggleLanguage} className="lang-btn">
            {lang === "tr" ? "EN" : "TR"}
          </button>
          <a
            href="https://www.medicana.com.tr/online-randevu?d=6g8OSll_QHs=&h=eJTRa8B9u7U=&b=O9z2njYFPJY="
            target="_blank"
            rel="noopener noreferrer"
            className="appointment-btn"
          >
            {content[lang].appointment}
          </a>
        </div>
      </header>

      <div>
        <section>
          <h1 className="page-title">{content[lang].media}</h1>
          <h2 className="section-title-2">Video</h2>
          <div className="carousel">
            <button
              className={`left-arrow ${currentIndex === 0 ? "disabled" : ""}`}
              onClick={prev}
              disabled={currentIndex === 0}
            >
              ←
            </button>
            <div className="carousel-track-container">
              <div
                className="carousel-track"
                style={{ transform: `translateX(-${currentIndex * 320}px)` }}
              >
                {videos.map((video, i) => (
                  <a href={video.link} key={i} target="_blank" rel="noreferrer">
                    <img src={video.src} alt={`video${i}`} />
                  </a>
                ))}
              </div>
            </div>
            <button
              className={`right-arrow ${
                currentIndex >= videos.length - 3 ? "disabled" : ""
              }`}
              onClick={next}
              disabled={currentIndex >= videos.length - 3}
            >
              →
            </button>
          </div>
        </section>

        <section className="media-section">
          <h2 className="section-title-2">{content[lang].yayın}</h2>
          <div className="articles">
            {articles.map((article, i) => (
              <div className="article-box" key={i}>
                <img src="https://img.icons8.com/ios/50/note.png" alt="doc" />
                <span>
                  {
                    <a
                      href={article.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {article.title}
                    </a>
                  }
                </span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
